<template>
  <vs-card v-if="showComponent">
    <div slot="header">
      <h3>Condutor {{ terceiro ? 'do Veículo do Terceiro' : null }}</h3>
    </div>
    <div>
      <div>
        <div class="vx-row">
          <!-- Condutor próprio associado -->
          <div class="vx-col sm:w-1/3 w-full mb-2" v-if="!terceiro">
            <label for class="vs-input--label"
              >Condutor próprio Beneficiário</label
            >
            <vs-switch
              v-model="formCondutor.condutorProprioAssociado"
              color="success"
              class="mt-2 ml-2"
              @change="
                formCondutor.condutorProprioAssociado
                  ? preencheFormCondutor('beneficiario')
                  : limpaFormCondutor()
              "
            >
              <span slot="on">sim</span>
              <span slot="off">não</span>
            </vs-switch>
          </div>

          <!-- Condutor habilitado -->
          <div class="vx-col sm:w-1/3 w-full mb-2">
            <label for class="vs-input--label">Condutor habilitado?</label>
            <vs-switch
              v-model="formCondutor.condutorHabilitado"
              color="success"
              class="mt-2 ml-2"
              @change="
                !formCondutor.condutorHabilitado
                  ? (formCondutor.dadosPessoaisCondutor.cnh = null)
                  : null
              "
            >
              <span slot="on">sim</span>
              <span slot="off">não</span>
            </vs-switch>
          </div>

          <!-- Existe parentesco com associado -->
          <div class="vx-col sm:w-1/3 w-full mb-2" v-if="!terceiro">
            <label for class="vs-input--label"
              >Existe parentesco com associado?</label
            >
            <vs-switch
              v-model="formCondutor.existeParentescoAssociado"
              color="success"
              class="mt-2 ml-2"
              :disabled="formCondutor.condutorProprioAssociado"
            >
              <span slot="on">sim</span>
              <span slot="off">não</span>
            </vs-switch>
          </div>
        </div>

        <div class="vx-row mt-4">
          <!-- Nome do Condutor -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <vs-input
              class="w-full"
              label="Nome do Condutor"
              v-model="formCondutor.dadosPessoaisCondutor.nome"
              name="Nome do Condutor"
              v-validate="{ required: true }"
              :state="validateState('Nome do Condutor')"
              :danger="validateClass('Nome do Condutor')"
            />
          </div>

          <!-- Data de Nascimento -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <label for class="vs-input--label">Data de Nascimento</label>
            <div class="inputData">
              <flat-pickr
                :config="configdateTimePicker"
                v-model="formCondutor.dadosPessoaisCondutor.dataNascimento"
                placeholder="DD/MM/AAAA"
                name="Data de liberação"
                :state="validateState('Data de Nascimento')"
                :danger="validateClass('Data de Nascimento')"
                @input="alteraIdade()"
              />
            </div>
          </div>

          <!-- Idade (em anos) -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <vs-input
              class="w-full"
              label="Idade (em anos)"
              v-model="formCondutor.dadosPessoaisCondutor.idade"
              name="Idade do Condutor"
              v-validate="{ required: true }"
              :state="validateState('Idade do Condutor')"
              :danger="validateClass('Idade do Condutor')"
              disabled
            />
          </div>

          <!-- Genero -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <label for="" class="vs-select--label">Gênero</label>
            <v-select
              class="selectStyle"
              :options="listGeneros"
              name="Status Evento"
              id="Status Evento"
              v-model="formCondutor.dadosPessoaisCondutor.genero"
              label="label"
              :reduce="(item) => item.id"
              v-validate="{ required: true }"
              :state="validateState('Gênero do Condutor')"
              :danger="validateClass('Gênero do Condutor')"
            ></v-select>
          </div>
        </div>

        <div class="vx-row mt-4">
          <!-- Celular -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <vs-input
              class="w-full"
              label="Celular"
              v-model="formCondutor.dadosPessoaisCondutor.celular"
              name="Celular do Condutor"
              v-validate="{ required: true }"
              :state="validateState('Celular do Condutor')"
              :danger="validateClass('Celular do Condutor')"
              v-mask="'(##) #####-####'"
            />
          </div>

          <!-- Telefone -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <vs-input
              class="w-full"
              label="Telefone"
              v-model="formCondutor.dadosPessoaisCondutor.telefone"
              name="Telefone do Condutor"
              v-validate="{ required: true }"
              :state="validateState('Telefone do Condutor')"
              :danger="validateClass('Telefone do Condutor')"
              v-mask="'(##) ####-####'"
            />
          </div>

          <!-- Email -->
          <div class="vx-col lg:w-1/2 w-full mb-2">
            <vs-input
              class="w-full"
              label="Email"
              v-model="formCondutor.dadosPessoaisCondutor.email"
              name="Email do Condutor"
              v-validate="{ required: true }"
              :state="validateState('Email do Condutor')"
              :danger="validateClass('Email do Condutor')"
            />
          </div>
        </div>

        <div class="vx-row mt-4">
          <!-- CNH do Condutor -->
          <div class="vx-col lg:w-1/3 w-full mb-2">
            <vs-input
              class="w-full"
              label="CNH"
              v-model="formCondutor.dadosPessoaisCondutor.cnh"
              name="CNH do Condutor"
              v-validate="{ required: true }"
              :state="validateState('CNH do Condutor')"
              :danger="validateClass('CNH do Condutor')"
              v-mask="'###########'"
              :disabled="!formCondutor.condutorHabilitado"
            />
          </div>

          <!-- CPF -->
          <div class="vx-col lg:w-1/3 w-full mb-2">
            <vs-input
              class="w-full"
              label="CPF"
              v-model="formCondutor.dadosPessoaisCondutor.cpf"
              name="CPF do Condutor"
              v-validate="{ required: true }"
              :state="validateState('CPF do Condutor')"
              :danger="validateClass('CPF do Condutor')"
              v-mask="'###.###.###-##'"
            />
          </div>

          <!-- RG -->
          <div class="vx-col lg:w-1/3 w-full mb-2">
            <vs-input
              class="w-full"
              label="RG"
              v-model="formCondutor.dadosPessoaisCondutor.rg"
              name="RG do Condutor"
              v-validate="{ required: true }"
              :state="validateState('RG do Condutor')"
              :danger="validateClass('RG do Condutor')"
            />
          </div>
        </div>

        <div class="vx-row mt-4">
          <!-- CEP -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <vs-input
              class="w-full"
              label="CEP"
              v-model="formCondutor.enderecoCondutor.cep"
              name="CEP do Condutor"
              v-validate="{ required: true, min: 10 }"
              :state="validateState('CEP do Condutor')"
              :danger="validateClass('CEP do Condutor')"
              v-mask="'##.###-###'"
              @keyup.native="buscaCep"
            />
          </div>

          <!-- Endereço -->
          <div class="vx-col lg:w-1/3 w-full mb-2">
            <vs-input
              class="w-full"
              label="Endereço"
              v-model="formCondutor.enderecoCondutor.rua"
              name="Rua do Condutor"
              v-validate="{ required: true }"
              :state="validateState('Rua do Condutor')"
              :danger="validateClass('Rua do Condutor')"
            />
          </div>

          <!-- Número -->
          <div class="vx-col lg:w-1/6 w-full mb-2">
            <vs-input
              class="w-full"
              label="Número"
              v-model="formCondutor.enderecoCondutor.numero"
              name="Número do Endereço do Condutor"
              v-validate="{ required: true }"
              :state="validateState('Número do Endereço do Condutor')"
              :danger="validateClass('Número do Endereço do Condutor')"
            />
          </div>

          <!-- Complemento -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <vs-input
              class="w-full"
              label="Complemento"
              v-model="formCondutor.enderecoCondutor.complemento"
              name="Complemento"
            />
          </div>
        </div>

        <div class="vx-row mt-4">
          <!-- Bairro -->
          <div class="vx-col lg:w-1/3 w-full mb-2">
            <vs-input
              class="w-full"
              label="Bairro"
              v-model="formCondutor.enderecoCondutor.bairro"
              name="Bairro do Condutor"
              v-validate="{ required: true }"
              :state="validateState('Bairro do Condutor')"
              :danger="validateClass('Bairro do Condutor')"
            />
          </div>

          <!-- Cidade -->
          <div class="vx-col lg:w-1/3 w-full mb-2">
            <vs-input
              class="w-full"
              label="Cidade"
              v-model="formCondutor.enderecoCondutor.cidade"
              name="Cidade do Condutor"
              v-validate="{ required: true }"
              :state="validateState('Cidade do Condutor')"
              :danger="validateClass('Cidade do Condutor')"
            />
          </div>

          <!-- Estado -->
          <div class="vx-col lg:w-1/3 w-full mb-2">
            <vs-input
              class="w-full"
              label="Estado"
              v-model="formCondutor.enderecoCondutor.estado"
              name="Estado do Condutor"
              v-validate="{ required: true }"
              :state="validateState('Estado do Condutor')"
              :danger="validateClass('Estado do Condutor')"
            />
          </div>
        </div>

        <!-- Profissão do Condutor -->
        <div class="vx-row mt-4">
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <vs-input
              class="w-full"
              label="Profissão do Condutor"
              v-model="formCondutor.dadosPessoaisCondutor.profissaoCondutor"
              name="Profissão do Condutor"
              :state="validateState('Profissão do Condutor')"
              :danger="validateClass('Profissão do Condutor')"
            />
          </div>
        </div>

        <!-- Observações -->
        <div class="vx-row mt-4">
          <div class="vx-col sm:w-1/1 w-full mb-2">
            <vs-textarea
              label="Observação sobre o Condutor para controle externo"
              v-model="formCondutor.observacaoSobreCondutor"
            />
          </div>
        </div>
      </div>
    </div>
  </vs-card>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
import vSelect from 'vue-select';
import functions from './../../../../../../../utils/functions';
import service from './../../../../../../../services';
import { condutor } from './../../../../shared/forms';
import dateConversion from '../../../../../../../utils/dateConversion';
import { decryptData } from './../../../../../../../services/decryptData';

export default {
  props: ['formData', 'dominios', 'terceiro'],
  watch: {
    formData(value) {
      if (!value.condutor) {
        this.showComponent = false;
        console.error('ERRO NO CONTRATO DO OBJETO - CONDUTOR FORM');
        return;
      }

      this.formCondutor = Object.assign(this.formCondutor, value.condutor);

      // eslint-disable-next-line vue/no-mutating-props
      this.formData.condutor = this.formCondutor;
    },
  },
  data() {
    return {
      showComponent: true,
      formCondutor: { ...condutor },

      listGeneros: [],

      // Configurações de Component
      configdateTimePicker: {
        dateFormat: 'd/m/Y',
        locale: Portuguese,
        time_24hr: true,
      },
    };
  },
  components: {
    flatPickr,
    vSelect,
  },

  methods: {
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    alteraIdade() {
      this.formCondutor.dadosPessoaisCondutor.idade = functions.calculaIdade(
        this.formCondutor.dadosPessoaisCondutor.dataNascimento,
      );
    },
    buscaCep() {
      if (this.formCondutor.enderecoCondutor.cep.length == 10) {
        this.$vs.loading();
        let cepbusca = this.formCondutor.enderecoCondutor.cep
          .replace('.', '')
          .replace('-', '');
        service
          .post('g', 'BuscaCEP', {
            cep: cepbusca,
          })
          .then((res) => {
            res.data = decryptData(res.data);
            this.formCondutor.enderecoCondutor.rua = res.data.street;
            this.formCondutor.enderecoCondutor.bairro = res.data.neighborhood;
            this.formCondutor.enderecoCondutor.cidade = res.data.city;
            this.formCondutor.enderecoCondutor.estado = res.data.state;
            this.formCondutor.enderecoCondutor.pais = res.data.country;
            this.$vs.loading.close();
          })
          .catch(() => {
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Não Foi possível encontrar o cep',
              color: 'danger',
            });
          });
      }
    },

    /**
     * Fills the driver form with client data.
     * @function
     * @returns {void}
     */
    preencheFormCondutor(isProprioAssociado) {
      const dadosPessoaisCondutor = {
        nome: this.formData.condutor.dadosPessoaisCondutor.nome,
        celular: this.formData.condutor.dadosPessoaisCondutor.celular,
        telefone: this.formData.condutor.dadosPessoaisCondutor.telefone,
        email: this.formData.condutor.dadosPessoaisCondutor.email,
        cnh: this.formData.condutor.dadosPessoaisCondutor.cnh,
        cpf: this.formData.condutor.dadosPessoaisCondutor.cpf,
        rg: this.formData.condutor.dadosPessoaisCondutor.rg,
        categoriaCnh: this.formData.condutor.dadosPessoaisCondutor.categoriaCnh,
        dataVencimentoCnh:
          this.formData.condutor.dadosPessoaisCondutor.dataVencimentoCnh,
        dataNascimento: dateConversion.converteISOToDate(
          this.formData.condutor.dadosPessoaisCondutor.dataNascimento,
        ),
      };

      const enderecoCondutor = {
        cep: this.formData.condutor.enderecoCondutor.cep,
        numero: this.formData.condutor.enderecoCondutor.numero,
        complemento: this.formData.condutor.enderecoCondutor.complemento,
        rua: this.formData.condutor.enderecoCondutor.endereco,
        bairro: this.formData.condutor.enderecoCondutor.bairro,
        cidade: this.formData.condutor.enderecoCondutor.cidade,
        estado: this.formData.condutor.enderecoCondutor.estado,
      };

      const dadosPessoaisCondutorProprioAssociado = {
        nome: this.formData.dadosCliente.nome,
        celular: this.formData.dadosCliente.celular,
        telefone: this.formData.dadosCliente.telefone,
        email: this.formData.dadosCliente.email,
        cnh: this.formData.dadosCliente.cnh,
        cpf: this.formData.dadosCliente.cpfcnpj,
        rg: this.formData.dadosCliente.rg_ie,
        categoriaCnh: this.formData.condutor.dadosPessoaisCondutor.categoriaCnh,
        dataVencimentoCnh:
          this.formData.condutor.dadosPessoaisCondutor.dataVencimentoCnh,
        dataNascimento: dateConversion.converteISOToDate(
          this.formData.dadosCliente.dataNascimento,
        ),
      };

      const enderecoCondutorProprioAssociado = {
        cep: this.formData.dadosCliente.cep,
        numero: this.formData.dadosCliente.numero,
        complemento: this.formData.dadosCliente.complemento,
        rua: this.formData.dadosCliente.endereco,
        bairro: this.formData.dadosCliente.bairro,
        cidade: this.formData.dadosCliente.cidade,
        estado: this.formData.dadosCliente.estado,
      };

      this.formCondutor.dadosPessoaisCondutor = isProprioAssociado
        ? dadosPessoaisCondutorProprioAssociado
        : dadosPessoaisCondutor;
      this.formCondutor.enderecoCondutor = isProprioAssociado
        ? enderecoCondutorProprioAssociado
        : enderecoCondutor;
      this.alteraIdade();
    },

    /**
     * Clears the driver's form fields.
     */
    limpaFormCondutor() {
      this.formCondutor.dadosPessoaisCondutor = {};
      this.formCondutor.enderecoCondutor = {};
    },
  },
  mounted() {
    if (!this.formData.condutor) {
      console.error('ERRO NO CONTRATO DO OBJETO - CONDUTOR FORM');
      this.showComponent = false;
    }

    // eslint-disable-next-line vue/no-mutating-props
    this.formData.condutor = this.formCondutor;

    if (this.dominios) {
      this.listGeneros = this.dominios.listGeneros;
    }

    this.preencheFormCondutor(this.formCondutor.condutorProprioAssociado);
  },
};
</script>
<style scoped>
.selectStyle {
  font-size: 1rem !important;
}
</style>
